import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Outlet } from 'react-router-dom';
import { SiteHeader } from '../header/SiteHeader';
import { Footer } from '../footer/Footer';
import { MobileHeaderPushProvider } from '../header/MobileHeaderPushContext';
import { ScrollRestorationManager } from '../navigation/ScrollRestorationManager';
const Layout = () => {
    return (_jsxs(MobileHeaderPushProvider, { children: [_jsx(ScrollRestorationManager, {}), _jsx(SiteHeader, {}), _jsx("div", { className: "relative h-full w-full", children: _jsx(Outlet, {}) }), _jsx(Footer, {})] }));
};
export default Layout;
